<template>
    <div>
        <span class="text-label-primary" :class="sModoCampo=='2'?'segundoEstiloTitulo':''">
            {{onValidarPlaceholder(sLabel)}} <span v-if="bObligatorio" class="red--text">*</span>
        </span>
        <v-text-field
            v-model="valor"
            v-bind="oAtributos"
            @keydown="onPrevenirSignos"
            :placeholder="sPlaceholderTemp==''?sPlaceholder:sPlaceholderTemp"
            class="mt-1"
            :error="bError"
            type="number"
            single-line
            outlined
            dense
        />
    </div>
</template>
<script>
export default {
    name: 'FormNumero',
    props: {
        value: {
        },
        oAtributos:{
            type:Object,
            default:()=>{}
        },
        bObligatorio:{
            type: Boolean,
            default: false,
        },
        sLabel:{
            type: String,
            default: "",
        },
        sModoCampo:{
            type: String,
            default: "1",
        },
        sGrupo:{
            type: String,
            default: "",
        },
        bError:{
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            valor: this.value,
            sPlaceholderTemp:""
        }
    },
    watch: {
        valor(NewValor) {
            this.$emit('input', NewValor)
        },
        value(NewValor){
            this.valor = NewValor
        }
    },
    methods : {
        onPrevenirSignos(event) { // Evita insertar el simbolo +/- en los input number
            const key = event.key
            if (key === "+" || key === "-") {
                event.preventDefault()
            }
        },
        onValidarPlaceholder(sLabelTemp){
            if(sLabelTemp!=""){
                let aTempPlaceholder = sLabelTemp.split("$$");
                if(aTempPlaceholder?.length>0){
                this.sPlaceholderTemp = aTempPlaceholder[1]
                }
                return aTempPlaceholder[0]
            }
        }
    }
}
</script>
<style scoped>
.segundoEstiloTitulo{
  color: #0056D3;
  font-size: medium;
}
</style>